<template>
  <div class="uk-flex-center" uk-grid>
    <div class="uk-width-large">
      <div class="uk-card uk-card-default uk-margin">
        <div class="uk-card-header uk-text-center">
          <h3 class="uk-card-title">{{ textType|capitalize }} - User Information</h3>
          <p class="uk-text-meta">{{ user.id }}</p>
        </div>
        <div class="uk-card-body">
          <user-form ref="form-user" type="manage" :user="user" />
        </div>
        <div class="uk-card-footer uk-text-center">
          <button class="uk-button uk-button-primary uk-margin-small-right" :disabled="disabled" @click="update">Update</button>
          <button class="uk-button uk-button-danger" @click="removeConfirm">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserForm from '@/components/form/User.vue'

export default {
  name: 'ComponentUserManage',

  components: { UserForm },

  props: {
    type: {
      type: Number,
      required: true
    },

    uid: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      formData: null,
      formComponent: null,
      user: null,
      loading: false
    }
  },

  computed: {
    textType() {
      const types = {
        1: 'admin',
        2: 'operator',
        3: 'dentist'
      }
      return types[this.type]
    },

    // NOTE: View Watchers
    source() {
      return this.$store.getters['users/find'](this.uid)
    },

    disabled() {
      const check = []
      let result = false

      check.push(this.formComponent ? !this.formComponent.observer.flags.valid : true)

      // Check if there is any change
      if (this.formData) {
        const updateCheck = [
          this.formData.email === this.user.email,
          this.formData.password === null,
          this.formData.name.first === this.user.name.first,
          this.formData.name.last === this.user.name.last
        ]

        check.push(!updateCheck.includes(false))
      }

      result = check.includes(true)

      return result
    }
  },

  watch: {
    // Added to prevent errors while user is being deleted
    // The data does not get erased immediatelly once user is removed
    source: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.user = newValue
        }
      }
    }
  },

  mounted() {
    this.formComponent = this.$refs['form-user']
    this.formData = this.formComponent.form
  },

  methods: {
    async update() {
      const loader = this.$loader.show('Updating User Record')
      const valid = await this.formComponent.validate()
      let result = null
      this.loading = true

      if (valid) {
        try {
          const updateUser = this.$firebaseFunctions.httpsCallable('updateUser')
          const data = {}

          if (this.formData.email !== this.mail) {
            data.email = this.formData.email
          }

          if (this.formData.password !== null) {
            data.password = this.formData.password
          }

          if (this.formData.name.first !== this.user.name.first || this.formData.name.last !== this.user.name.last) {
            if (data.hasOwnProperty('name')) {
              data.name.first = this.formData.name.first
              data.name.last = this.formData.name.last
            } else {
              data.name = {}
              data.name.first = this.formData.name.first
              data.name.last = this.formData.name.last
            }
          }

          data.uid = this.uid
          result = await updateUser(data)
        } catch (error) {
          result = error
          await loader.hide(true)
          this.loading = false
          this.$uikit.notification(error, { status: 'danger' })
        }
      }

      if ((result instanceof Error !== true) && result.data.status === 'success') {
        await loader.hide()
        this.loading = false
        this.$uikit.modal.alert(`${this.$options.filters.capitalize(this.textType)} User was updated successfully!`)

        if (this.type === 3) {
          this.$router.push({ name: 'dentist-manage', params: { id: this.user.dentist } })
        } else {
          this.$router.push({ name: `${this.textType}-list` })
        }
      }
    },

    async removeConfirm() {
      this.$uikit.modal.confirm('Are you sure that you want to delete this user?').then(() => {
        this.remove()
      })
    },

    async remove() {
      const loader = this.$loader.show('Deleting User Record')
      let result = null
      const dentist = this.type === 3 ? this.user.dentist : null

      try {
        const deleteUser = this.$firebaseFunctions.httpsCallable('deleteUser')
        result = await deleteUser({ uid: this.uid })
      } catch (error) {
        result = error
        await loader.hide(true)
        this.$uikit.notification(error, { status: 'danger' })
      }

      if ((result instanceof Error === false) && result.data.status === 'success') {
        await loader.hide()
        this.$uikit.modal.alert(`${this.$options.filters.capitalize(this.textType)} User was deleted successfully!`)

        if (this.type === 3) {
          this.$router.push({ name: 'dentist-manage', params: { id: dentist } })
        } else {
          this.$router.push({ name: `${this.textType}-list` })
        }
      }
    }
  }
}
</script>
